// DS: DS4.2, DS4.2.1
import React from 'react';
import c from 'classnames';
import BiInput from '@wix/da-bi/pkg/Components/BiInput';
import CheckIcon from '../Icons/Check';
import s from './Checkbox.scss';
export const Checkbox = ({ id, name, size = 'big', originalGreen, children, isChecked, hasError, halfChecked, className, inputClassName, labelClassName, innerRef, disabled, ariaLabel, ariaLabelledBy, onChange, onClick, biData, tabIndex })=>{
    const icon = isChecked && halfChecked ? /*#__PURE__*/ React.createElement("div", {
        className: c(s['icon'], s['icon-dash'])
    }) : /*#__PURE__*/ React.createElement(CheckIcon, {
        className: c(s['icon'], s['icon-check']),
        customSizable: true
    });
    return /*#__PURE__*/ React.createElement("label", {
        className: c(s['root'], isChecked && s['checked'], disabled && s['disabled'], hasError && s['has-error'], s[`size-${size}`], !originalGreen && s['new-colors'], className),
        onClick: onClick,
        tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0
    }, /*#__PURE__*/ React.createElement(BiInput, {
        type: "checkbox",
        id: id,
        name: name,
        checked: isChecked,
        disabled: disabled,
        onChange: (e)=>{
            onChange && onChange(!isChecked, e);
        },
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        biData: biData,
        innerRef: innerRef
    }), /*#__PURE__*/ React.createElement("div", {
        className: c(s['checkbox'], inputClassName)
    }, icon), children && /*#__PURE__*/ React.createElement("span", {
        className: c(s['label'], labelClassName)
    }, children));
};
Checkbox.displayName = 'Checkbox';
export default Checkbox;

//# sourceMappingURL=Checkbox.js.map